export default "__VITE_ASSET__CnAz0WUr__"